export type AddToOrderGuideResponse = {
  success: boolean;
  categoryName: string;
  itemNumber: string;
};

const addToOrderGuide = async (
  orderGuides: {
    userId: string;
    categoryName: string;
    quantity: string;
    itemNumber: string;
  }[],
): Promise<AddToOrderGuideResponse[]> => {
  const addToOrderGuideEndpoint = "/api:orderguide/addtoorderguide/";

  const body = new FormData();
  body.set("orderGuides", JSON.stringify(orderGuides));

  const orderGuidesAdded = await fetch(addToOrderGuideEndpoint, {
    body,
    method: "POST",
    credentials: "include",
  }).then(async (response) => {
    return response.json<AddToOrderGuideResponse[]>();
  });

  return orderGuidesAdded;
};

export default addToOrderGuide;
